import React from "react";
import Roles from "../../enums/Roles";

class RentalFilters extends React.Component {
  render() {
    const {
      selectedMonth,
      selectedYear,
      selectedStatus,
      selectedEstablishment,
      establishments,
      searchTerm,
      searchPlaceholder,
      userRole,
      onMonthChange,
      onYearChange,
      onStatusChange,
      onEstablishmentChange,
      onSearchChange,
      onSyncClick,
      onExportClick,
    } = this.props;

    // Generate month options
    const monthNames = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];

    // Generate year options
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let i = currentYear - 2; i <= currentYear + 2; i++) {
      yearOptions.push(i);
    }

    const isAdmin = userRole === Roles.ADMIN || userRole === Roles.SALES_REP;

    return (
      <>
        {/* Ligne 1 : Filtres */}
        <div className="row mb-3">
          <div className="col-6 col-md-4 col-lg-2 mb-2">
            <label className="form-label">Mois</label>
            <select
              className="form-control"
              value={selectedMonth}
              onChange={onMonthChange}
            >
              {monthNames.map((month, index) => (
                <option key={index + 1} value={index + 1}>
                  {month}
                </option>
              ))}
            </select>
          </div>
          <div className="col-6 col-md-4 col-lg-2 mb-2">
            <label className="form-label">Année</label>
            <select
              className="form-control"
              value={selectedYear}
              onChange={onYearChange}
            >
              {yearOptions.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
          <div className="col-6 col-md-4 col-lg-2 mb-2">
            <label className="form-label">Statut</label>
            <select
              className="form-control"
              value={selectedStatus}
              onChange={onStatusChange}
            >
              <option value="all">Tous les statuts</option>
              <option value="en_attente">À traiter</option>
              <option value="en_preparation">En préparation</option>
              <option value="a_livrer">À livrer</option>
              <option value="actif">Actif</option>
              <option value="attente_fin">Fin demandée</option>
              <option value="termine">Terminé</option>
              <option value="date_depassee">Date dépassée</option>
            </select>
          </div>
          {/* Filtre par établissement - visible seulement pour Admin/Sales */}
          {isAdmin && (
            <div className="col-6 col-md-4 col-lg-2 mb-2">
              <label className="form-label">Établissement</label>
              <select
                className="form-control"
                value={selectedEstablishment || "all"}
                onChange={onEstablishmentChange}
              >
                <option value="all">Tous les établissements</option>
                {establishments && establishments.map((establishment) => (
                  <option key={establishment._id} value={establishment._id}>
                    {establishment.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="col-12 col-md-4 col-lg-4 mb-2">
            <label className="form-label">Rechercher</label>
            <input
              type="text"
              className="form-control"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={onSearchChange}
            />
          </div>
        </div>

        {/* Ligne 2 : Boutons d'actions alignés à droite */}
        <div className="d-flex justify-content-end mb-4" style={{ gap: "10px" }}>
          {/* Bouton Synchroniser DM - visible seulement pour Admin/Sales */}
          {isAdmin && (
            <button
              className="btn rental-sync-button d-flex align-items-center justify-content-center"
              onClick={onSyncClick}
            >
              <i className="fas fa-sync-alt rental-sync-button-icon"></i>
              <span className="tooltip-trigger tooltip-left" data-tooltip="Synchroniser les dispositifs médicaux du parc">
                Synchro DM du parc
              </span>
            </button>
          )}
          {/* Bouton Exporter */}
          <button
            className="btn rental-export-button d-flex align-items-center justify-content-center"
            onClick={onExportClick}
          >
            <i className="fas fa-file-excel"></i>
            <span>Exporter</span>
          </button>
        </div>
      </>
    );
  }
}

export default RentalFilters;
